import { Image } from 'components/Image';
import { Text } from 'components/Text';
import { classNames, useState } from 'libs/react';
import { React } from 'libs/react';
import { FormIconCheckBox } from 'components/form/FormIconCheckBox';
import { Money } from 'components/Money';
import { Icon } from 'components/Icon';
import { SaleItemViewer } from 'components/saleItem/SaleItemViewer';
import { useModal } from 'components/modal/ModalStack';
import { FormInput } from 'components/form/FormInput';
import { stockLabel, stockState } from 'helpers/inventory';
import { getFieldValueLabel } from 'helpers/Field';
import './SaleItemCard.scss';
import { getPromotionPrice } from 'helpers/promotionPrice';
import { FORM_CARD_SIZES, imageSources } from 'helpers/mediaSources';
/**
 * @component SaleItemCard
 * @since 1.0.0
 */
export function SaleItemCard(props) {
    var _a, _b, _c, _d, _e, _f, _g;
    const { item, lang, selected, hasDirectSales, variant, selectedOptionCount = 0, selectedAccent = 'green', uncheckedToggleLabel = 'icon' } = props;
    const modal = useModal();
    const [quantity, setQuantity] = useState(1);
    const translation = item.translations.find((entry) => entry.language.code === lang);
    const variantTranslation = (_a = variant === null || variant === void 0 ? void 0 : variant.translations) === null || _a === void 0 ? void 0 : _a.find((entry) => entry.language.code === lang);
    const variantTitle = (variantTranslation === null || variantTranslation === void 0 ? void 0 : variantTranslation.title) || (variant === null || variant === void 0 ? void 0 : variant.title);
    const variantValues = (_c = (_b = variant === null || variant === void 0 ? void 0 : variant.values) === null || _b === void 0 ? void 0 : _b.map((value) => `${value.field.title} : ${getFieldValueLabel(value.value, value.field, lang)}`)) !== null && _c !== void 0 ? _c : [];
    const price = (_d = variant === null || variant === void 0 ? void 0 : variant.price) !== null && _d !== void 0 ? _d : item.price;
    const promoPrice = getPromotionPrice(price, item.promotions);
    const showPrice = hasDirectSales && item.configuration === 'FINISHED';
    const stock = stockState(item, quantity);
    const stockText = hasDirectSales ? stockLabel(stock) : null;
    const soldOut = hasDirectSales && stock.soldOut;
    /**
     * @function onQuantityChange
     * @since 1.0.0
     * @hidden
     */
    function onQuantityChange(value) {
        var _a;
        const nextQuantity = Math.max(1, Math.min(Number(value) || 1, stock.maxQuantity));
        setQuantity(nextQuantity);
        if (selected && props.onQuantityChange) {
            props.onQuantityChange(item.id, nextQuantity);
        }
        else {
            (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, item.id, nextQuantity);
        }
    }
    /**
     * @function onSaleItemCardClick
     * @since 1.0.0
     */
    const onSaleItemCardClick = () => {
        var _a;
        if (soldOut && !selected)
            return;
        (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, item.id, quantity);
    };
    /**
     * @function onToggleChange
     * @since 1.0.0
     * @hidden
     */
    function onToggleChange(event) {
        var _a;
        event === null || event === void 0 ? void 0 : event.stopPropagation();
        if (soldOut && !selected)
            return;
        (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, item.id, quantity);
    }
    /**
     * @function onSaleItemDetail
     * @since 1.0.0
     * @hidden
     */
    function onSaleItemDetail() {
        var _a;
        if (item) {
            modal.present({
                title: (_a = translation === null || translation === void 0 ? void 0 : translation.title) !== null && _a !== void 0 ? _a : item.sku,
                picto: '',
                className: 'deal-sale-item-selector-item-modal',
                modal: React.createElement(SaleItemViewer, { item: item, variant: variant, lang: lang })
            });
        }
    }
    /**
     * @function onSaleItemDetailClick
     * @since 1.0.0
     * @hidden
     */
    function onSaleItemDetailClick(event) {
        event.stopPropagation();
        onSaleItemDetail();
    }
    const className = classNames('sale-item-card', {
        'sale-item-card--selected': selected,
        'sale-item-card--selected-primary': selected && selectedAccent === 'primary',
        'sale-item-card--has-options': selected && selectedOptionCount > 0,
        'sale-item-card--sold-out': soldOut && !selected
    });
    const image = (_e = variant === null || variant === void 0 ? void 0 : variant.image) !== null && _e !== void 0 ? _e : (_f = item.image) === null || _f === void 0 ? void 0 : _f.image;
    const title = (_g = translation === null || translation === void 0 ? void 0 : translation.title) !== null && _g !== void 0 ? _g : item.sku;
    return (React.createElement("div", { className: className, onClick: onSaleItemCardClick },
        React.createElement("div", { className: "sale-item-card__head" }, (image === null || image === void 0 ? void 0 : image.url) ? (React.createElement(Image, Object.assign({ className: "sale-item-card__image", lazy: true }, imageSources(image, FORM_CARD_SIZES)))) : (React.createElement("div", { className: "sale-item-card__placeholder", "aria-hidden": "true" },
            React.createElement(Icon, { value: "image" })))),
        React.createElement("div", { className: "sale-item-card__body" },
            React.createElement("div", { className: "sale-item-card__body-header" },
                React.createElement(Text, { value: translation === null || translation === void 0 ? void 0 : translation.title, className: "sale-item-card__title" }),
                React.createElement("button", { type: "button", className: "sale-item-card__info-btn", "aria-label": `${t('More information')} – ${title}`, onClick: onSaleItemDetailClick },
                    React.createElement(Icon, { value: "circle-info", className: "sale-item-card__info" }))),
            variant && (React.createElement("div", { className: "sale-item-card__variant" },
                variantTitle && (React.createElement(Text, { value: variantTitle, className: "sale-item-card__variant-title" })),
                variantValues.map((value) => (React.createElement(Text, { key: value, value: value, className: "sale-item-card__variant-value" }))))),
            (translation === null || translation === void 0 ? void 0 : translation.summary) && (React.createElement(Text, { html: true, value: translation.summary, className: "sale-item-card__summary" })),
            selected && selectedOptionCount > 0 && (React.createElement(Text, { value: `${selectedOptionCount} ${t('option(s) selected')}`, className: "sale-item-card__options-count" })),
            stockText && (React.createElement(Text, { value: stockText, className: classNames('sale-item-card__stock', {
                    'sale-item-card__stock--sold-out': stock.soldOut
                }) }))),
        React.createElement("div", { className: "sale-item-card__footer", onClick: (event) => event.stopPropagation() },
            uncheckedToggleLabel === 'add' ? (React.createElement("button", { type: "button", className: classNames('sale-item-card__toggle', {
                    'sale-item-card__toggle--selected': selected
                }), "aria-pressed": selected, "aria-label": `${selected ? t('Remove') : t('Add')} – ${title}`, onClick: onToggleChange }, selected ? React.createElement(Icon, { value: "check" }) : t('Add'))) : (React.createElement(FormIconCheckBox, { checked: selected, checkedColor: "primary", checkedIcon: "fal check", uncheckedIcon: "fal plus", onChange: () => onToggleChange() })),
            showPrice && (React.createElement(React.Fragment, null,
                React.createElement(FormInput, { type: "number", name: "quantity", size: "small", className: "sale-item-card__quantity", value: quantity.toString(), onChange: onQuantityChange }),
                promoPrice !== null ? (React.createElement("div", { className: "sale-item-card__price-promo" },
                    React.createElement(Money, { value: price, className: "sale-item-card__price--original" }),
                    React.createElement(Money, { value: promoPrice, className: "sale-item-card__price--promo" }))) : (React.createElement(Money, { value: price, className: "sale-item-card__price" })))))));
}
